module.exports = __webpack_public_path__ + "static/img/collect.4f3e4ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/collect.png
// module id = rlCU
// module chunks = 3